<template>
  <div class="login-box">
    <div class="container">
      <div class="login-title" ref="popTitle">{{ $t('login') }}</div>
      <el-form
        :model="loginForm"
        :style="{ height: scrollHeight + 'px' }"
        status-icon
        ref="loginForm"
        label-width="100px"
        label-position="top">
        <el-form-item
          prop="email"
          :label="$t('editpage.text3')"
          :rules="[
            {
              required: true,
              message: $t('loginpage.text19'),
              trigger: 'blur'
            },
            {
              type: 'email',
              message: $t('loginpage.text18'),
              trigger: ['blur', 'change']
            }
          ]">
          <el-input v-model.trim="loginForm.email" clearable></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('loginpage.text13')"
          prop="code"
          :rules="[
            {
              required: true,
              message: $t('loginpage.text17'),
              trigger: 'blur'
            }
          ]">
          <el-input
            type="password"
            show-password
            v-model="loginForm.code"
            clearable></el-input>
          <el-button class="code-btn"
            ><span v-if="!timer" @click="handleSendCode">{{
              $t('loginpage.text14')
            }}</span
            ><span v-else>{{ $t('new.text23') }} {{ time }}s</span></el-button
          >
        </el-form-item>
        <!-- <ReCaptCha @getToken="getToken" v-if="showRecaptcha" /> -->
        <div class="hide-box">
          <el-button
            :loading="loading"
            type="primary"
            @click="submitForm('loginForm')"
            class="block el-button--special"
            >{{ $t('login') }}</el-button
          >
          <div v-html="$t('add.text97')"></div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postLoginBabe, postUserInfoBabe } from '@/api/babe'
import { postLoginMcn, postUserInfoMcn } from '@/api/mcn'
import { postEmailCode, postLogin, postUserInfo } from '@/api/user'
// import ReCaptCha from '@/components/ReCaptCha'
import { Toast } from 'mint-ui'

export default {
  components: {
    // ReCaptCha
  },
  data() {
    return {
      loginForm: {
        email: '',
        code: '',
        recaptcha_code: ''
      },
      loading: false,
      timer: null,
      time: 60,
      showRecaptcha: false,
      scrollHeight: 0
    }
  },
  created() {
    this.showRecaptcha = true
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight =
        document.documentElement.clientHeight -
        this.$refs.popTitle.clientHeight -
        this.$store.state.remTopx * (0.17 + 0.37 + 0.05)
    })
  },
  beforeDestroy() {
    this.showRecaptcha = false
    clearInterval(this.timer)
  },
  methods: {
    getToken(token) {
      this.loginForm.recaptcha_code = token
      console.log(token)
    },
    handleSendCode() {
      this.$refs['loginForm'].validateField('email', (errorMsg) => {
        if (errorMsg) {
        } else {
          this.timer = setInterval(() => {
            if (this.time > 1) {
              this.time -= 1
            } else {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
          postEmailCode({ email: this.loginForm.email }).then((res) => {
            if (res.errorCode === 0) {
              Toast({
                message: this.$t('loginpage.text4'),
                iconClass: 'icon icon-success'
              })
            } else {
              Toast({
                message: res.errorMsg,
                iconClass: 'icon icon-error'
              })
            }
          })
        }
      })
    },
    submitForm(form) {
      localStorage.removeItem('selectedAddress')
      this.$refs[form].validate((valid) => {
        if (valid) {
          // if (this.loginForm.recaptcha_code === '') {
          //   this.$toast({
          //     message: 'Please check Robot validation',
          //     iconClass: 'icon icon-error'
          //   })
          //   return
          // }
          if (localStorage.getItem('inviteCode')) {
            this.loginForm.rec_code = localStorage.getItem('inviteCode')
          }
          this.loading = true
          if (this.$store.state.role === 'user') {
            postLogin(this.loginForm)
              .then((res1) => {
                Toast({
                  message: this.$t('loginpage.text2'),
                  iconClass: 'icon icon-success',
                  duration: 2000
                })
                this.loading = false
                setTimeout(() => {
                  this.$store.dispatch('Login', res1.data)
                  postUserInfo().then((res) => {
                    this.$store.dispatch('UserInfo', res.data)
                    this.$emit('handleLoginBack', res1.data.first_login)
                  })
                }, 2000)
              })
              .catch(() => {
                this.loading = false
              })
          } else if (this.$store.state.role === 'babe') {
            postLoginBabe(this.loginForm)
              .then((res) => {
                Toast({
                  message: this.$t('loginpage.text2'),
                  iconClass: 'icon icon-success'
                })
                this.loading = false
                setTimeout(() => {
                  this.$store.dispatch('Login', res.data)
                  this.$emit('handleLoginBack')
                  postUserInfoBabe().then((res) => {
                    this.$store.dispatch('UserInfo', res.data)
                  })
                }, 2000)
              })
              .catch(() => {
                this.loading = false
              })
          } else if (this.$store.state.role === 'mcn') {
            postLoginMcn(this.loginForm)
              .then((res) => {
                Toast({
                  message: this.$t('loginpage.text2'),
                  iconClass: 'icon icon-success'
                })
                this.loading = false
                setTimeout(() => {
                  this.$store.dispatch('Login', res.data)
                  this.$emit('handleLoginBack')
                  postUserInfoMcn().then((res) => {
                    this.$store.dispatch('UserInfo', res.data)
                  })
                }, 2000)
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.login-box {
  .el-form {
    overflow-y: scroll;
    .el-form-item__content {
      display: flex;
      .el-button {
        margin-left: 0.1rem;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.login-box {
  background-color: #383838;
  border-top: 0.05rem solid #505050;
  padding: 0.17rem 0 0.37rem;

  .login-title {
    font-size: 0.18rem;
    font-weight: bold;
    text-align: center;
    padding-bottom: 0.35rem;
    text-transform: uppercase;
    font-family: 'Montserrat';
  }
}
#grecaptcha > div {
  width: 100% !important;
  iframe {
    width: 100%;
  }
}
.rc-anchor-light {
  background: #000000;
}
.rc-anchor-light.rc-anchor-normal,
.rc-anchor-normal {
  width: 100% !important;
}
.el-button--special {
  font-size: 0.16rem;
  margin: 0.3rem 0 0.4rem;
}
.des {
  color: rgba(255, 255, 255, 0.38);
  line-height: 0.16rem;
  margin-bottom: 0.1rem;
}
.code-btn {
  width: 1.2rem;
}

@media (max-height: 400px) {
  .hide-box {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue